import request from '@/shared/api/request';

export const addDatabaseFirewallRules = (
  database_uuid: string,
  data: { rules: { address: string }[] },
): Promise<unknown> =>
  request({
    url: `/databases/${database_uuid}/firewall/`,
    method: 'POST',
    data,
  });
